// import { useState, useEffect } from 'react';


interface ToastProps {
    text: string
}

export function Toast({ text }: ToastProps) {
    // const [visible, setVisible] = useState(true);

    // useEffect(() => {
    //     setVisible(true);
    //     const timer = window.setTimeout(() => {
    //         setVisible(false);
    //     }, 2600);

    //     return () => {
    //         window.clearTimeout(timer);
    //     }
    // }, [text])

    // if (!visible) return null;
    return (
        <div className='toast-overlay'>

        <div className="toast">
            <p>{text}</p>
        </div>
        </div>

    );
}